(function(){
'use strict';
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
var $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};
var par=[];
function initPar(root){$$('[data-parallax]',root).forEach(function(el){if(el.dataset.p)return;el.dataset.p=1;par.push(el)})}
function tick(){par.forEach(function(el){var r=el.parentNode.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;var p=(r.top+r.height/2-innerHeight/2)/innerHeight;el.style.transform='translate3d(0,'+(p*-6)+'%,0) scale(1.02)'})}
if(!reduce){addEventListener('scroll',function(){requestAnimationFrame(tick)},{passive:true})}
function initCount(root){
  $$('[data-count]',root).forEach(function(el){
    if(el.dataset.c)return;el.dataset.c=1;
    var end=parseFloat(el.getAttribute('data-count'))||0,dec=(String(end).split('.')[1]||'').length;
    if(reduce||!('IntersectionObserver' in window)){el.textContent=end.toFixed(dec);return}
    el.textContent=(0).toFixed(dec);
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;io.disconnect();var t0=performance.now(),d=1600;(function f(now){var k=Math.min(1,(now-t0)/d);k=1-Math.pow(1-k,4);el.textContent=(end*k).toFixed(dec);if(k<1)requestAnimationFrame(f)})(t0)})},{threshold:.4});
    io.observe(el);
  });
}
function initAnatomy(root){
  $$('[data-anatomy]',root).forEach(function(a){
    if(a.dataset.a)return;a.dataset.a=1;
    var spots=$$('.spot',a),chips=$$('.chip',a),board=a.querySelector('.board'),pop=a.querySelector('.pop'),tpl=a.querySelector('.pop-data'),cur=-1;
    var data=tpl?[].slice.call((tpl.content||tpl).querySelectorAll('i')).map(function(i){return {t:i.getAttribute('data-t'),x:i.getAttribute('data-x')}}):[];
    if(!pop||!data.length)return;
    var n=pop.querySelector('.pop-n'),t=pop.querySelector('.pop-t'),x=pop.querySelector('.pop-x');
    function on(i,go){
      i=(i+data.length)%data.length;cur=i;
      spots.concat(chips).forEach(function(s){s.setAttribute('aria-pressed',Number(s.dataset.i)===i?'true':'false')});
      n.textContent='Detail '+(i+1)+' of '+data.length;t.textContent=data[i].t;x.textContent=data[i].x;
      pop.hidden=false;pop.style.animation='none';void pop.offsetWidth;pop.style.animation='';
      if(go){var r=board.getBoundingClientRect();if(r.top<70||r.bottom>innerHeight)board.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'})}
    }
    spots.forEach(function(s){s.addEventListener('click',function(){on(Number(s.dataset.i),false)})});
    chips.forEach(function(c){c.addEventListener('click',function(){on(Number(c.dataset.i),true)})});
    pop.querySelector('.pop-prev').addEventListener('click',function(){on(cur-1,false)});
    pop.querySelector('.pop-next').addEventListener('click',function(){on(cur+1,false)});
    on(0,false);
  });
}
function init(root){initPar(root);initCount(root);initAnatomy(root);tick()}
init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
